
import React, { useState, useRef } from "react";
import {
    Box,
    Typography,
    Toolbar,
    InputAdornment,
    IconButton,
    Popover,
    Button,
    TextField
} from "@mui/material";
import {ContainerClasses} from '../../themes/containerClasses'
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import MenuIcon from "@mui/icons-material/Menu";
import CheckIcon from "@mui/icons-material/Check";
import ScheduleIcon from "@mui/icons-material/Schedule";
import AccountCircle from "@mui/icons-material/AccountCircle";
import {useTheme} from '@mui/material/styles';
import {LayoutFieldModel} from '../../models/models';
import { DateField } from "@mui/x-date-pickers/DateField";
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import dayjs from 'dayjs';


export const DateFieldComponent: React.FC<{
  layoutField: LayoutFieldModel,
  value: string,
  onChange: (value: Date, layoutField: LayoutFieldModel) => void,
}> = ( {
  layoutField,
  value,
  onChange
}) => {

  const initValue = () => {
    if(value !== null) return new Date(value)
    //check defaults
    if(!layoutField.ReferencedField_sys.DefaultValue_sys) return new Date()
    if(!layoutField.ReferencedField_sys.DefaultValue_sys.type) return new Date()
    if(layoutField.ReferencedField_sys.DefaultValue_sys.value === null) return new Date()
    if(layoutField.ReferencedField_sys.DefaultValue_sys.type === 'constant') return new Date(layoutField.ReferencedField_sys.DefaultValue_sys.value)
    if(layoutField.ReferencedField_sys.DefaultValue_sys.type === 'backend_function') return new Date()
    if(layoutField.ReferencedField_sys.DefaultValue_sys.type === 'frontend_function') return new Date() //TODO: calculate frontend function

    return new Date()
  }

  const [error, setError] = useState(false);
  const [open, setOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState<Date>(initValue());
  const anchorRef = useRef<HTMLDivElement | null>(null);

  const handleChange = (newCalendarValue: any) => {
    const value = new Date(newCalendarValue);
    onChange(value, layoutField);
  }

  const openCalendar = (event: React.MouseEvent<HTMLElement>) => {
    setOpen(true);
  }

  const closeCalendar = () => {
    setOpen(false);
    const value = new Date(selectedDate);
    onChange(value, layoutField);
  }

  const changeDate = (date: Date) => {
    setSelectedDate(date);
  }


  return (
    <>
        <Box ref={anchorRef}>
          <DateField
             disabled={true}
             variant="filled"
             fullWidth
             label={layoutField.ReferencedField_sys.Label_sys}
             value={dayjs(value)}
             format="DD.MM.YYYY"
             onChange={(newCalendarValue: any) => handleChange(newCalendarValue)}
            InputProps={{
              disableUnderline: true,
              endAdornment: (
                layoutField.AccessSetting_sys !== 'read' &&
                <InputAdornment position="end">
                  <IconButton size="small" onClick={(event) => openCalendar(event)}>
                    <ScheduleIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
            >
          </DateField>
          </Box>

          <Popover
            open={open}
            anchorEl={anchorRef.current}
            onClose={closeCalendar}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left'
            }}
          >
            <Box>
              <DateCalendar
                disabled={layoutField.AccessSetting_sys === 'read'}
                value={dayjs(selectedDate)}
                onChange={(newCalendarValue: any) => changeDate(newCalendarValue)}
              />
            </Box>
            <Box
               sx={{display: "flex",
                    justifyContent: "flex-end"}}
            >
              <Button
                 size="small"
                 onClick={() => closeCalendar()}
                 variant='contained'
              >
                  <CheckIcon />
              </Button>
            </Box>
          </Popover>
      </>
    );



};
